export default "__VITE_ASSET__CKPWWHYo__"